import { FooterContentFragment } from "../../../graphql/graphql.ts";
import { linkTransformer } from "../../../data/transformer/linkTransformer.ts";
import { C102FooterProps } from "./C102Footer.tsx";
import { LocaleConfig } from "../../../utils/GlobalContext.ts";

export function footerTransformer(
  entry: FooterContentFragment,
  localeConfig: LocaleConfig,
): C102FooterProps | null {
  if (!entry) {
    return null;
  }

  const { linksCollection, secondaryLinksCollection, cookiePreferencesLabel } =
    entry;

  return {
    cookiePreferencesLabel,
    links:
      linksCollection?.items
        .filter(Boolean)
        .map((link) => linkTransformer({ link, localeConfig })) ?? [],
    secondaryLinks:
      secondaryLinksCollection?.items
        .filter(Boolean)
        .map((link) => linkTransformer({ link, localeConfig })) ?? [],
  };
}
